import { Injectable } from "@angular/core";

declare let fbq: Function;

@Injectable({
  providedIn: 'root'
})
export class FacebookPixelService {
  constructor() { }

  init(pixelId: string): void {
    if (typeof fbq !== 'undefined') {
      fbq('init', pixelId);
      fbq('track', 'PageView');
    }
  }

  trackEvent(eventName: string, eventData?: any): void {
    if (typeof fbq !== 'undefined') {
      fbq('track', eventName, eventData);
    }
  }
}
